import { SpaceProps } from '@wrisk/styled-system'
import React, { FunctionComponent } from 'react'

import { getCurrentQuote, isCoverActive } from '../../../domain'
import { useDiscountCovers } from '../../../hooks/covers'
import { TKey } from '../../../infrastructure/internationalisation'
import { useProposal } from '../../product/proposal/ProposalProvider'
import { PromotionBanner } from './PromotionBanner'
import { PromotionNotification } from './PromotionNotification'

const tKey = TKey('components.promotion-banner')

export const ProposalPromotionBanner: FunctionComponent<SpaceProps> = (props) => {
  const { proposal } = useProposal()

  const quote = getCurrentQuote(proposal)
  const [discount] = useDiscountCovers(quote)
  const promoCode = quote.promoCode

  return promoCode && discount && isCoverActive(discount) ? (
    <PromotionBanner tKey={tKey} promoCode={promoCode} {...props} />
  ) : promoCode ? (
    <PromotionNotification promoCode={promoCode} {...props} />
  ) : null
}
